module.exports = __webpack_public_path__ + "img/scrap.cf03687e.jpg";